"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var class_regex_1 = require("../class-regex");
var get_class_1 = require("../get-class");
var has_class_1 = require("../has-class");
function removeClass(element, className) {
    if (element && has_class_1.default(element, className)) {
        var regex = class_regex_1.default(className);
        element.setAttribute('class', get_class_1.default(element)
            .replace(regex, ' ')
            .trim());
    }
}
exports.default = removeClass;
function removeClassFactory(className) {
    return function (element) {
        removeClass(element, className);
    };
}
exports.removeClassFactory = removeClassFactory;
function removeClassOnCollection(elements, className) {
    elements.forEach(removeClassFactory(className));
}
exports.removeClassOnCollection = removeClassOnCollection;
